import { min } from 'lib/array/arrayUtils'

const isSoloTraveller = (capacities: Array<App.RoomCapacity>) => {
  if (!capacities || capacities.length === 0) return false
  return capacities.every(cap => cap.adults === 1 && cap.children === 0 && cap.infants === 0 && cap.teenagers === 0)
}
export function getLowestPricePackage(
  offer: App.HotelOffer | App.TourOffer | App.BundledOffer | App.HotelOfferSummary | App.TourOfferSummary | App.VillaOffer | App.BundleOffer,
  offerPackages: Array<App.HotelPackage>,
) {
  const defaultOptions = new Set(offer.defaultOptions)
  let packages = offerPackages.filter(x => defaultOptions.has(x.uniqueKey))
  packages = packages.length > 0 ? packages : offerPackages

  // Temporary fix to exclude solo traveller packages
  const filteredSoloPackages = packages.filter(pkg => !isSoloTraveller(pkg.roomRate?.capacities ?? []))
  packages = filteredSoloPackages.length > 0 ? filteredSoloPackages : packages

  return min(packages, pkg => (pkg.memberPrice || pkg.price) + (pkg.surcharge ?? 0) || Number.MAX_SAFE_INTEGER)
}
